module.exports = __webpack_public_path__ + "static/img/header4.935b891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/header4.jpg
// module id = ZOOn
// module chunks = 1